module.exports = "### How React Works\n\n- Not magic, but pretty close\n\n- React uses \"Virtual DOM\" to abstract the DOM into JS objects\n\n- Change is detected --> `render` is called\n\n- React looks at entire component tree\n\n- Diffing algorithm compares changes in virtual DOM\n\n- Decides parts of tree to rerender\n\n- Batches changes for efficiency\n\n- Updates the actual DOM\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/09_how_it_works/notes_2.md
// module id = 1516
// module chunks = 0